/**
 * Tiny local `gettext`/`ngettext` replacing `@eventbrite/i18n`.
 *
 * The eb-ui shim's `gettext` returns a lazy `GenericLazyString` object that is
 * unsafe to render directly in React 19 and has no `ngettext`; per the memory
 * recipe we return PLAIN STRINGS with `%(name)s`-style interpolation. A
 * consuming Valkyrie app that needs real translations wires react-intl at the
 * app level and passes translated strings via the component `text` props; this
 * keeps the library dependency-free and render-safe.
 */
export const gettext = (
    template: string,
    params: Record<string, string | number> = {},
): string =>
    template.replace(/%\((\w+)\)s/g, (_match, key: string) =>
        key in params ? String(params[key]) : `%(${key})s`,
    );

export const ngettext = (
    singular: string,
    plural: string,
    count: number,
): string => (count === 1 ? singular : plural);
